/* eslint-disable @typescript-eslint/no-explicit-any */
import { CSS_KEY_BLOCKLIST_RAW } from '../settings';
const CSS_KEY_BLOCKLIST = new Set(CSS_KEY_BLOCKLIST_RAW.map(k => k.toLowerCase()));

export function ensureGlobalTooltip(tooltip: any) {
  const host: Element = (document as any).fullscreenElement ?? document.body;
  if (tooltip.parentNode !== host) {
    tooltip.parentNode?.removeChild(tooltip);
    host.appendChild(tooltip);
  }
  Object.assign(tooltip.style, {
    position: 'fixed',
    zIndex: '2147483647',
    pointerEvents: 'auto',
    maxWidth: 'min(420px, 90vw)',
  } as Partial<CSSStyleDeclaration>);

  if (!tooltip._copyHandlerBound) {
    tooltip.addEventListener('click', async (ev: MouseEvent) => {
      const btn = (ev.target as HTMLElement).closest('.copy-btn') as HTMLElement | null;
      if (!btn) return;
      ev.preventDefault();
      ev.stopPropagation();
      const value = decodeURIComponent(btn.getAttribute('data-copy-value') || '');
      try {
        if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(value);
        else {
          const ta = document.createElement('textarea');
          ta.value = value;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
      } catch (e) { console.error(e); }
    });
    tooltip._copyHandlerBound = true;
  }
}

export function showTooltip(
  element: any,
  tooltip: HTMLElement,
  pointer?: { x: number; y: number }
) {
  ensureGlobalTooltip(tooltip);

  const data = element.data();
  tooltip.innerHTML = `
  <div class="flex flex-col space-y-1 pointer-events-auto">
    ${Object.entries(data)
    .filter(([k]) => !CSS_KEY_BLOCKLIST.has(String(k).toLowerCase()))
    .sort((a, b) => String(a[0]).localeCompare(String(b[0]), undefined, { sensitivity: 'base', numeric: true }))
    .map(([key, value]) => `
        <div class="text-xs flex items-start justify-between gap-2">
          <div class="min-w-0 overflow-hidden">
            <span class="font-semibold text-gray-800">${String(key)}:</span>
            <span class="text-gray-500 break-all">${String(value)}</span>
          </div>
          <button type="button" class="copy-btn text-gray-400 hover:text-gray-500 shrink-0 inline-flex items-center rounded px-1.5 py-1 hover:bg-gray-100"
            data-copy-value="${encodeURIComponent(String(value))}" title="Kopieren" aria-label="Wert kopieren">
            <span class="e-icons e-copy"></span>
          </button>
        </div>`).join('')}
  </div>`;

  tooltip.classList.remove('hidden');

  tooltip.style.left  = '0px';
  tooltip.style.top   = '0px';
  tooltip.style.width = ''; 

  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const pad = 8; 
  const maxContentWidthPx = Math.min(420, Math.floor(0.9 * vw)); 

  let cx: number, cy: number;
  if (pointer) {
    cx = pointer.x; cy = pointer.y;
  } else {
    const bb = element.renderedBoundingBox();
    const crect = element.cy().container().getBoundingClientRect();
    cx = crect.left + (bb.x1 + bb.x2) / 2;
    cy = crect.top  + (bb.y1 + bb.y2) / 2;
  }

  const left = Math.round(cx);
  const availableRight = Math.max(0, vw - pad - left);
  const width = Math.min(maxContentWidthPx, availableRight);

  tooltip.style.left  = `${left}px`;
  tooltip.style.width = `${width}px`;

  const rect = tooltip.getBoundingClientRect();
  let top = Math.round(cy - rect.height / 2);

  if (top < pad) top = pad;
  if (top + rect.height > vh - pad) top = Math.max(pad, vh - rect.height - pad);

  tooltip.style.top = `${top}px`;
}

